import { render } from "./SearchBox.vue?vue&type=template&id=b3db499a&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=b3db499a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3db499a"]])

export default __exports__